/**
 *
 * @name script
 * @author MohammedSaleem
 * @fileOverview generic script that links different css functionality across aplication,
 * viz on-button-click,popup.
 */


$(document).ready(function () {
    let parentEle = $('body');
    fun = {
        dropDown: function () {
            parentEle.on('click', '.dropDown .head ,.multiSelect .head', function (e) {
                e.stopPropagation();

                if (!$(this).parent().hasClass('disabled')) {
                    let init = $(this).data('init');
                    if (!$(this).parent().hasClass('open')) {
                        $('.dropDown .list, .multiSelect .list').slideUp(100);
                        $('.dropDown .head, .multiSelect .head').data({
                            'init': '0',
                        });
                        $('.dropDown').removeClass('open');
                        $('.multiSelect').removeClass('open');

                        $(this).parents().eq(0).addClass('open');
                        $(this).parents().eq(0).find('.list').slideDown(200);
                        $(this).data({
                            'init': '1',
                        });
                    } else {
                        $(this).parents().eq(0).find('.list').slideUp(200);
                        $(this).data({
                            'init': '0',
                        });
                        let ele = $(this);
                        setTimeout(function () {
                            ele.parents().eq(0).removeClass('open');
                        }, 150);
                    }
                }
            });
            parentEle.on('click', '.dropDown .list:not(.cameraConfig) li', function (e) {
                let value = $(this).text().trim();
                $(this).parents().eq(1).find('.headTitle').focus();
                $(this).parents().eq(1).find('.headTitle').text(value);
                $(this).parents().eq(1).find('.headTitle').val(value);
                $(this).parents().eq(1).find('#defaultLabel').hide();
                $(this).parent().slideUp(200);
                $(this).parents().eq(1).find('.head').data({
                    'init': '0',
                });

                let ele = $(this);
                setTimeout(function () {
                    ele.parents().eq(1).removeClass('open');
                }, 150);
            });

            parentEle.on('click', '.dropDown .list.cameraConfig li .txt', function (e) {
                let value = $(this).text().trim();
                $(this).parents().eq(2).find('.headTitle').focus();
                $(this).parents().eq(2).find('.headTitle').text(value);
                $(this).parents().eq(2).find('.headTitle').val(value);

                $(this).parents().eq(1).slideUp(200);
                $(this).parents().eq(2).find('.head').data({
                    'init': '0',
                });

                let ele = $(this);
                setTimeout(function () {
                    ele.parents().eq(2).removeClass('open');
                }, 150);
            });

            parentEle.on('click', '.dropDown .list li .configBtn', function (e) {
                let ele = $(this);
                $(this).parents().eq(1).slideUp(200);
                setTimeout(function () {
                    ele.parents().eq(2).removeClass('open');
                }, 150);
            });

            parentEle.on('click', '.dropDown .list li a', function (e) {
                let value = $(this).text().trim();
                $(this).parents().eq(2).find('.headTitle').focus();
                $(this).parents().eq(2).find('.headTitle').text(value);
                $(this).parents().eq(2).find('.headTitle').val(value);

                $(this).parents().eq(1).slideUp(200);
                $(this).parents().eq(2).find('.head').data({
                    'init': '0',
                });

                let ele = $(this);
                setTimeout(function () {
                    ele.parents().eq(2).removeClass('open');
                }, 150);
            });
            $('body').on('click', function (e) {
                setTimeout(function () {
                    $('.multiSelect').removeClass('open');
                }, 150);
            });
            parentEle.on('click', '.multiSelect:not(.multiSelectComp) .list li', function (e) {
                e.stopPropagation();
                let that = this;
                let listHeader = $(this).parents().eq(1).find('.headTitle');
                let selectedVal = '';
                let selectedValArray = [];
                setTimeout(function () {
                    selectionLen = $(that).parent().find('input[type=\'checkbox\']:checked').length;

                    if (selectionLen == 0) {
                        listHeader.text('Please select');
                    } else {
                        $(that).parent().find('input[type=\'checkbox\']:checked').each(function () {
                            selectedValArray.push($(this).parents().eq(1).find('.listName').text().trim());
                            if (selectedValArray.length > 2) {
                                selectedVal = selectedValArray[0] + ', ' + selectedValArray[1] + ' + ' + (selectedValArray.length - 2);
                            } else {
                                selectedVal = selectedValArray.toString();
                            }
                        });
                        listHeader.text(selectedVal);
                        listHeader.val(selectedVal);
                        // console.log(selectedVal);
                    }
                }, 50);
            });

            parentEle.on('keyup', '.dropDown.appAutocomplete .headTitle', function (e) {
                $(this).parents().eq(1).addClass('open');
                $(this).parents().eq(1).find('.list').slideDown(200);
                $(this).data({
                    'init': '1',
                });
            });

        },
        toggleButton: function () {
            parentEle.on('click', '.toggleBtn:not(.disabled)', function (e) {
                e.stopPropagation();
                let init = $(this).data('init');
                if ($(this).hasClass('on')) {
                    $(this).removeClass('on').addClass('off');
                } else {
                    $(this).removeClass('off').addClass('on');
                }
            });
        },
        slideBox: function () {
            parentEle.on('click', '.slideBox', function (e) {
                e.stopPropagation();
                $('.slideBox').removeClass('show');
                $(this).addClass('show');
            });
            parentEle.on('click', '.slideBox li', function (e) {
                e.stopPropagation();
                $('.slideBox').removeClass('show');
            });
        },
        popup: function (btn, popup) {
            parentEle.on('click', btn, function (e) {
                e.stopPropagation();
                $(popup).parent().append('<div class="background"></div>');
                setTimeout(() => {
                    $('.background').fadeIn(300);
                    $('.popup').fadeOut(0);
                    $(popup).fadeIn(300);
                    $('body,html').scrollTop(0);
                }, 100)
            });

            parentEle.on('click', '.popup .close', function (e) {
                e.preventDefault();
                e.stopPropagation();
                $('.popup').fadeOut(300);
                $('.background').fadeOut(300);
                setTimeout(() => {
                    $('.background').remove();
                }, 400)
            });
        },
        accordion: function () {
            parentEle.on('click', '.accordionSec .accordionHead',
                function (e) {
                    e.stopPropagation();
                    let init = $(this).data('init');

                    if (!$(this).parent().hasClass('expand') && !$(this).parent().hasClass('open')) {
                        // $(this).parents().eq(1).find('.accordionSec').removeClass('expand')
                        //     .find('.accordionContent').slideUp(300);
                        // $(this).parents().eq(1).find('.accordionHead').data({
                        //     'init': 0,
                        // });

                        $(this).parent()
                            .addClass('expand')
                            .find('> .accordionContent').slideDown(300);
                        $(this).data({
                            'init': 1,
                        });

                        if ($(this).parent().hasClass('selectable')) {
                            $('.accordionSec .accordionHead').removeClass('selected');
                            $(this).addClass('selected');
                        }

                    } else {
                        $(this).parent()
                            .removeClass('expand')
                            .find('.accordionContent').slideUp(300);

                        $(this).parent()
                            .find('.accordionSec').removeClass('expand');

                        $(this).data({
                            'init': 0,
                        }).removeClass('selected');

                        if ($(this).parent().hasClass('open')) {
                           setTimeout(() => {
                               $(this).parent()
                                   .removeClass('open')
                           }, 300)
                        }
                    }
                });
        },
        defaultClick: function () {
            $(document).click(function () {
                $('.dropDown .list, .multiSelect .list').slideUp(200);
                $('.dropDown .head, .multiSelect .head').data({
                    'init': '0',
                });
                $('.dropDown').removeClass('open');
                $('.multiSelect').removeClass('open');


                $('.slideBox').removeClass('show');
            });
        },
        preventDefaultClicks: function () {
            let selectors = '.slidingContent';
            parentEle.on('click', selectors, function (e) {
                e.stopPropagation();
            });
        }
    };
    fun.dropDown();
    //fun.toggleButton();
    fun.slideBox();
    fun.accordion();
    fun.defaultClick();
    // fun.preventDefaultClicks();


    fun.popup('.upDatasetBtn', '.upDatasetPopup');
    fun.popup('.trainModelBtn', '.trainModelPopup');
});
